import React, { Component } from 'react';
// @ts-ignore
import CanvasJSReact from '@canvasjs/react-charts';
interface RangeBarChartProps {
    data: {

		dataPoints: any;
		monthName: any;
		leadsCreatedThisMonth: number; label: string, value: number 
}[];
}


const { CanvasJSChart } = CanvasJSReact;

class RangeBarChart extends Component <RangeBarChartProps>  {
    render() {
        const {data} = this.props; 
		let cumulativeSum = 0;
        const adjustedData = data.map(item => {
            cumulativeSum += item.leadsCreatedThisMonth;
            return { label: item.monthName, y: item.leadsCreatedThisMonth };
        });

        // Push the "Final" data point into adjustedData with additional properties
        adjustedData.push({
            label: "End",
            y: cumulativeSum,         
         
        });

 
        const options = {
            animationEnabled: true,
            axisY: {
                //valueFormatString: "$#,##0,.K",
                includeZero: true,
                lineThickness: 0,
                tickThickness: 0,
                gridThickness: 0,
				labelFontFamily: "Roboto", // Font family for y-axis labels
                labelFontColor: "#08425C", // Color for y-axis labels
				labelFontSize: 12,
            },
            axisX: {
                lineThickness: 1,
                tickThickness: 0,
                gridThickness: 0,
				interval: 1,
				labelFontFamily: "Roboto", // Font family for X-axis labels
                labelFontColor: "#08425C", // Color for X-axis labels
				labelFontSize: 12,	
				// barThickness: 50,		
            },
			dataPointMaxWidth: 57,
            data: [{
                type: "waterfall",	
				isCumulativeSum: true,				
                risingColor: "#93D063",
                fallingColor: "#F44336",		
               // yValueFormatString: "$#,##0,.00K",
               // indexLabel: "+{y[#index]}",
                dataPoints: adjustedData.map((item:any,index:Number) => ({
					label: item.label,
                    y: item.y,							
					indexLabel: item.y=== 0 ? ' ' : (index === adjustedData.length - 1 ? `{y}` : `+{y}`),
                    indexLabelFontSize: 12,
                    indexLabelFontColor:'black',
                    indexLabelFontStyle:'Arial',
					color: item.label === "End" ? "#CBD5EA" : undefined,
                    isCumulativeSum: item.label === "End",
								
                })),
				
            }],
			
        };

        return (
            <div className='barchart'>
                <CanvasJSChart options={options} />
            </div>
        );
    }
}

export default RangeBarChart;
